import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SubscriptionPlanModelInterface } from 'src/app/interface/subscription-plan-model.interface';
import { OpenIdProfileBase } from 'src/app/mixin/presets';
import { OpenIdService } from 'src/app/service/open-id.service';

@Component({
    selector: 'app-view-subscriptions-plans-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.css'],
})
export class DetailComponent extends OpenIdProfileBase implements OnInit {
    public formGroup = new FormGroup({
        label: new FormControl(),
        description: new FormControl(),
        webhook: new FormControl(),
    });

    public message?: string;

    public planId: number = 0;
    public planModel: SubscriptionPlanModelInterface;

    constructor(
        private httpClient: HttpClient,
        openIdService: OpenIdService,
        private route: ActivatedRoute
    ) {
        super(openIdService);
        this.planModel = {} as SubscriptionPlanModelInterface;
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.planId = Number(params['id']);
            if (this.planId > 0) {
                this.getPlan();
            }
        });
    }

    private getPlan() {
        this.httpClient
            .get<SubscriptionPlanModelInterface>(
                `subscription_plans/${this.planId}`
            )
            .subscribe((planModel: SubscriptionPlanModelInterface) => {
                this.planModel = planModel;
                this.formGroup.setValue({
                    label: planModel.label,
                    description: planModel.description,
                    webhook: planModel.webhook,
                });
            });
    }

    public savePlan() {
        if (this.planId > 0) {
            this.httpClient
                .put(`subscription_plans/${this.planId}/`, this.planModel)
                .subscribe((resp) => {
                    this.message = 'Saved';
                });
        } else {
            this.httpClient
                .post('subscription_plans/', this.planModel)
                .subscribe((resp) => {
                    this.message = 'Created';
                });
        }
    }

    public validate() {
        if (this.formGroup.invalid) {
            return;
        }

        this.message = 'Saving ...';

        this.planModel.label = this.formGroup.get('label')?.value;
        this.planModel.description = this.formGroup.get('description')?.value;
        this.planModel.webhook = this.formGroup.get('webhook')?.value;

        if (this.planId == 0) {
            this.planModel.receiver_open_id = this.openIdProfile!.id;
            this.planModel.subscriber_overdraft = true;
        }

        this.savePlan();
    }
}
